


const ResetPassword = () => {
    return (
      <div>ResetPassword</div>
    )
  }
  
  export default ResetPassword
  